import React from "react"
import PageLayout from "../layouts/page-layout"

const NotFound = () => (
  <PageLayout>
    <h1>404: Not Found</h1>
  </PageLayout>
)

export default NotFound
